import React, {
  useEffect,
} from 'react';
import {
  useSelector,
  useDispatch,
} from 'react-redux';

import * as actions from 'chronos-actions';
import * as selectors from 'chronos-selectors';

import {
  InitialLoader,
  ViewControls,
} from 'chronos-components';

import {
  FilterContainer,
  Sidebar,
  CalendarContainer,
  TimelineContainer,
  FooterContainer,
  DatePickerContainer,
  ConfirmDeleteWorklogModal,
  GuideContainer,
  WorklogModal,
  ScreenshotsViewerModal,
  FlagsContainer,
} from 'chronos-containers';

import refreshIcon from 'chronos-assets/images/refresh.svg';

import * as S from './styled';


const mapState = state => ({
  ...selectors.getUiState([
    'contextView',
    'showGuide',
    'initializeInProcess',
    'jiraType',
  ])(state),
});

const AppContainer = () => {
  const {
    contextView,
    showGuide,
    initializeInProcess,
    jiraType,
  } = useSelector(mapState);
  const dispatch = useDispatch();

  useEffect(() => {
    try {
      if (jiraType === 'server') {
        window.document.getElementById("content").style.height = "calc(100% - 41px)";
      }
      window.document.getElementsByTagName("body")[0].style['overflow-y'] = 'hidden';
    } catch (err) {
      console.log(err);
    }
  }, [jiraType]);

  return (
    <S.Page
      onKeyDown={e => (
        e.key === 'Shift'
        && (
          dispatch(actions.setUiState({
            shiftKeyDown: true,
          }))
        )
      )}
      onKeyUp={e => (
        e.key === 'Shift'
        && (
          dispatch(actions.setUiState({
            shiftKeyDown: false,
          }))
        )
      )}
    >
      {
        initializeInProcess
          ? (
            <InitialLoader size="xlarge" />
          ) : (
            <>
              <div>
                {
                  showGuide
                    && (
                      <GuideContainer
                        onFinish={() => {
                          localStorage.setItem('showChronosGuide', 'false');
                          dispatch(actions.setUiState({
                            showGuide: false,
                          }));
                        }}
                      />
                    )
                }
              </div>
              <S.Content>
                {
                  contextView === 'calendar'
                  && (
                    <Sidebar />
                  )
                }
                <S.SubscopeContextWrapper>
                  <S.ContextWrapper>
                    <S.ContextHeader>
                      <DatePickerContainer />
                      <FilterContainer />
                      <S.RefreshIcon
                        src={refreshIcon}
                        onClick={() => {
                          dispatch(actions.refreshRequest());
                        }}
                      />
                      <ViewControls
                        selected={contextView}
                        onClick={(cv) => {
                          localStorage.setItem('chronosContextView', cv);
                          dispatch(actions.setUiState({ contextView: cv }));
                        }}
                      />
                    </S.ContextHeader>
                    {contextView === 'calendar' && <CalendarContainer />}
                    {contextView === 'timeline' && <TimelineContainer />}
                  </S.ContextWrapper>
                </S.SubscopeContextWrapper>
              </S.Content>
              <FooterContainer />
              <ConfirmDeleteWorklogModal />
              <WorklogModal />
              <ScreenshotsViewerModal />
              <FlagsContainer />
            </>
          )
      }
    </S.Page>
  );
};

export default AppContainer;
